module.exports = "<div> <iframe-template path-url={{url}} css=100% key=searchDeclarationDetail></iframe-template> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/declaration/addValTaxDeclaration/searchDeclaration/view/searchDeclarationDetail.html
// module id = Gk9X
// module chunks = 0